import { Button } from '@mui/material';

const CustomButtonOutlined = ({
  onClick = () => {},
  startIcon = null,
  sx = {},
  title,
  ...rest
}) => {
  return (
    <Button
    {...rest}
      sx={{
        ...sx,
        px: {md : '20px', xs : 1},
        py: {md : '8px', xs : 0.8},
        fontSize: {md : '0.875rem', xs : '13px'}
      }}
      color="primary"
      variant="outlined"
      startIcon={startIcon}
      onClick={onClick}
    >
      {title}
    </Button>
  );
};

export default CustomButtonOutlined;
